import { useState } from 'react';
import { Edit, Board } from '@vibe/icons';
import { IconButton, Button } from '@vibe/core';
import { BoardPickerModal } from '@gorilla/ui/src/components/BoardPickerModal';
import { useAllBoards } from '../shared/hooks/use-boards';

type EditableBoardProps = {
  selectedBoardId?: number;
  onChange: (newSelectedBoardId?: number) => void;
  buttonMode: 'pencil' | 'choose';
};

export function EditableBoard({ onChange, buttonMode, selectedBoardId }: EditableBoardProps) {
  const [showBoardPicker, setShowBoardPicker] = useState(false);

  return (
    <>
      {showBoardPicker ? (
        <BoardPickerModal
          show={showBoardPicker}
          useBoards={useAllBoards}
          onClose={(boardId) => {
            if (boardId) {
              onChange(boardId);
            }

            setShowBoardPicker(false);
          }}
        />
      ) : null}
      <div
        style={{
          marginLeft: 'auto',
        }}
      >
        {buttonMode === 'choose' ? (
          <Button
            kind="secondary"
            size="medium"
            leftIcon={Board}
            onClick={() => {
              setShowBoardPicker(true);
            }}
          >
            Choose board
          </Button>
        ) : (
          <IconButton
            kind="secondary"
            size="medium"
            icon={Edit}
            onClick={() => {
              setShowBoardPicker(true);
            }}
            className="custom__deletepagebutton"
          />
        )}
      </div>
    </>
  );
}
